const PACKAGE_TYPE = {
  BOXBERRY: 1,
  USER: 0,
};

const CITIES_CODES = {
  MOSCOW: '68',
  SAINT_PETERSBURG: '116',
};

const DELIVERY_TYPES = {
  DOOR_TO_DOOR: 1,
  DOOR_TO_PVZ: 2,
  PVZ_TO_DOOR: 3,
  PVZ_TO_PVZ: 4,
};

const REGION_NAME = {
  MOSCOW: 'Москва',
  MOSCOW_OBLAST: 'Московская',
  SAINT_PETERSBURG: 'Санкт-Петербург',
  LENINGRAD_OBLAST: 'Ленинградская',
};

const COUNTRY_CODES = {
  RUSSIA: '643',
  KAZAKHSTAN: '398',
  BELARUS: '112',
  KYRGYZSTAN: '417',
  ARMENIA: '051',
  TAJIKISTAN: '762',
  UZBEKISTAN: '860',
};

const CALC_PIP = {
  MIN_PRICE: '1000',
  MIN_PRICE_KZ_KZ: '5500',
  MAX_PRICE_KZ_KZ: '490 000',
};

const MOBILE_STORES = {
  GOOGLE_PLAY: 'https://redirect.appmetrica.yandex.com/serve/171095108517656711',
  APP_STORE: 'https://redirect.appmetrica.yandex.com/serve/99037499229211636',
  APP_GALLERY: 'https://appgallery.huawei.com/#/app/C103283299',
}

export {
  PACKAGE_TYPE, CITIES_CODES, DELIVERY_TYPES, REGION_NAME, COUNTRY_CODES, CALC_PIP, MOBILE_STORES,
};
